/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo, useEffect } from 'react'
import { trackInternalEvent } from '@rio/tracking'

import { useSyncedQueryParams } from 'builder/hooks/useSyncedQueryParams'
import { CategoryIds } from '../../CategoryTabs'
import { MappedProgressData } from '../types'

export default function useProgressTrackerTab(
  categoryId: CategoryIds,
  progressData?: MappedProgressData,
) {
  const storedServiceID = localStorage.getItem(`lastServiceId:${categoryId}`)

  const [data] = useMemo(() => [progressData?.[categoryId] || []], [categoryId, progressData])
  const defaultServiceId = storedServiceID ?? data[0].id
  const { value2: activeServiceId, setValue2: setActiveServiceId } = useSyncedQueryParams(
    'categoryTab',
    categoryId,
    'serviceId',
    defaultServiceId,
  )

  const handleSetActiveServiceId = (id: string) => {
    const service = data.find(s => s.id === id) || data[0]
    setActiveServiceId(id)
    trackInternalEvent('progress_score_click', { score: service?.title })
  }

  useEffect(() => {
    /**
     * This side effect is needed to ensure that the current activeServiceId
     * is always a valid service id. If the activeServiceId is not found
     * in the data array, we set it to the defaultServiceId.
     */
    if (!data.some(s => s.id === activeServiceId)) {
      handleSetActiveServiceId(defaultServiceId)
    }
  }, [data, categoryId, defaultServiceId])

  const selectedService = data.find(s => s.id === activeServiceId) || data[0]

  return { data, activeServiceId, setActiveServiceId: handleSetActiveServiceId, selectedService }
}
